import { inject, type Ref } from 'vue'
import type { CombinedError, UseQueryState } from '@urql/vue'
import type { EnquiryFormContentFragment, InitQuery } from '@/graphql/api'

import type { Benchmark } from '@/plugins/bench.ts'

export const initKey = 'app.plugin.init'

export interface InitPlugin {
    error: Ref<CombinedError | undefined>
    initQueryResponse: UseQueryState<InitQuery>
    isInitialized: Ref<boolean>
    promise: Promise<void>
    benchmark: Benchmark
    enquiryFormContent: Readonly<
        Ref<Record<string, EnquiryFormContentFragment>>
    >
}

export function useInit(): InitPlugin {
    return inject(initKey) as InitPlugin
}
